import * as Sentry from '@sentry/react';

import type { UserT } from '@/stores/UserStore';

import type { WorkspaceInfo } from './types';

/**
 * Sentry 사용자 설정
 * - 로그인 성공 후 호출
 */
export function setSentryUser(user: UserT, workspaceInfo?: WorkspaceInfo): void {
  Sentry.setUser({
    id: user.user_id,
    email: user.email,
    username: `${user.firstName} ${user.lastName}`.trim(),
  });

  if (workspaceInfo) {
    Sentry.setContext('workspace', {
      alias: workspaceInfo.alias,
      name: workspaceInfo.name,
    });
    Sentry.setTag('workspace.alias', workspaceInfo.alias);
  }
}

/**
 * Sentry 사용자 초기화
 * - 로그아웃 시 호출
 */
export function clearSentryUser(): void {
  Sentry.setUser(null);
  Sentry.setContext('workspace', null);
}

/**
 * 워크스페이스 전환 시 업데이트
 */
export function updateSentryWorkspace(alias: string, name?: string): void {
  Sentry.setContext('workspace', { alias, name });
  Sentry.setTag('workspace.alias', alias);
}
